import snippets from './snippets';

const entity = snippets('widgetSnippets');

const reducer = entity.reducer;
export {reducer as default, entity};
